import { Typography } from '@mui/material';

import { Base02TextContainer, Container, LeftContainer, TextColumnContainer } from './styled';

import { ReactComponent as RightChevronIcon } from 'src/assets/svg/RightChevron.svg';

type TxSelectButtonProps = {
  title: string;
  subtitle: string;
  onClick?: (isClicked: boolean) => void;
};

export default function TxSelectButton({ title, subtitle, onClick }: TxSelectButtonProps) {
  return (
    <Container
      onClick={() => {
        onClick?.(true);
      }}
      data-is-onclick={onClick ? 1 : 0}
    >
      <LeftContainer>
        <TextColumnContainer>
          <Typography variant="h4">{title}</Typography>
          <Base02TextContainer>
            <Typography variant="h7">{subtitle}</Typography>
          </Base02TextContainer>
        </TextColumnContainer>
      </LeftContainer>
      <RightChevronIcon />
    </Container>
  );
}
